import { render, staticRenderFns } from "./VideoCardTags.vue?vue&type=template&id=a4dc9772&scoped=true"
import script from "./VideoCardTags.vue?vue&type=script&lang=js"
export * from "./VideoCardTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc9772",
  null
  
)

export default component.exports